import Cookies from 'js-cookie';

const expires = parseInt(process.env.REACT_APP_SESSION_EXPIRE) || 1;

export function setToken(token) {
    Cookies.set('access-token', token, {expires});
}

export function setRefreshToken(token) {
    Cookies.set('refresh-token', token, {expires});
}

export function removeToken() {
    Cookies.remove('access-token');
}

export function removeRefreshToken() {
    Cookies.remove('refresh-token');
}


export function setUserData(data) {
    localStorage.setItem('user-data', data);
}

export function removeUserData() {
    localStorage.removeItem('user-data');
}